import { asMDICaseID, asMDIPatientID } from "@repo/db/branded-types";
import { Case } from "@repo/provider-network";
import {
  CASE_STATUS_MAP,
  getLatestTimestamp,
  reduceToNewestCase,
} from "src/lib/data";
import { KinsaInitialContext } from "src/lib/definitions";
import { Routes, getVisitUrl } from "src/lib/routes";

export async function determineCaseStatus(
  patientVisits: Case[],
  initialContext: KinsaInitialContext
): Promise<{ status: string | null; route: string | null }> {
  const { newestCase, caseTimestamp } = reduceToNewestCase(patientVisits);
  const nullCase = { status: null, route: null };

  if (!newestCase) return nullCase;

  const lastSensorTimestamp = initialContext.component
    ? getLatestTimestamp(initialContext.component)
    : null;

  if (!newestCase.case_status) return nullCase;
  const mdiStatus = newestCase.case_status.name;
  const caseStatus = CASE_STATUS_MAP[mdiStatus];

  // Handle new sensor data
  if (
    lastSensorTimestamp &&
    caseTimestamp &&
    lastSensorTimestamp > caseTimestamp
  ) {
    // TODO: Figure out what to do when there's new sensor data, but an active case
    if (caseStatus === "completed") return nullCase;
  } else {
    if (caseStatus === "completed") {
      const patientId = newestCase.patient?.patient_id;
      if (!patientId || !newestCase.case_id) return nullCase;
      return {
        status: "completed",
        route: getVisitUrl(patientId, newestCase.case_id),
      };
    }
  }

  if (caseStatus === "requested") {
    return { status: "requested", route: Routes.HOME };
  }

  if (caseStatus === "active") {
    const patientId = newestCase.patient?.patient_id;
    if (!patientId || !newestCase.case_id) {
      return nullCase;
    }
    return {
      status: "active",
      route: getVisitUrl(
        asMDIPatientID(patientId),
        asMDICaseID(newestCase.case_id)
      ),
    };
  }

  return nullCase;
}
